import { combineReducers } from "redux";
// import { counterReducer } from "./counter";
// import { LoginReducer } from "./login";
import { languageReducer } from "./lang";
import { newSystemReducer } from "./system";
import { newFactReducerStep1, newFactReducerStep3 } from "./addFact";
import {
  checkInFactReducer,
  ADDFactsIdReducer,
  TicketsIdReducer,
  PlantIDReducer,
} from "./inFact";
import { UserRoleReducer , UserAccountLevelReducer} from "./user";
import { authState } from "./auth";

export const reducers = combineReducers({
  lang_change: languageReducer,
  add_system: newSystemReducer,
  add_fact_step1: newFactReducerStep1,
  add_fact_step3: newFactReducerStep3,
  in_fact: checkInFactReducer,
  facts_id: ADDFactsIdReducer,
  tickets_id: TicketsIdReducer,
  user_role: UserRoleReducer,
  account_level: UserAccountLevelReducer,
  plant_id:PlantIDReducer,
  authState
});
